import "./CommonLink.css";

import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";

import { copyToClipboard } from "core/clipboard_utils";
import { getUrlFromText } from "core/request_utils";

const CommonLink = ({ urlStr, withCopyButton }) => {
	return (
		<div className="common-link" style={{ display: "flex" }} title={urlStr}>
			<div
				style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
				onClick={() => {
					if (urlStr) {
						if (String(urlStr).includes("@")) {
							window.open(`mailto:${urlStr}`);
						} else if (String(urlStr).includes(".")) {
							window.open(getUrlFromText({ text: urlStr }));
						}
					}
				}}
			>
				{urlStr}
			</div>

			{withCopyButton && (
				<div title="Копировать" onClick={() => copyToClipboard(urlStr)}>
					<ContentCopyOutlinedIcon
						sx={{ color: "#272727", fontSize: 12, cursor: "pointer", position: "relative", top: 1, marginLeft: "2px" }}
					/>
				</div>
			)}
		</div>
	);
};

export default CommonLink;
